module.exports = __webpack_public_path__ + "static/media/shipSize-box.19aed670.svg";